import React from 'react';
import { createPortal } from 'react-dom';
import { X, ShoppingCart, Trash2, Heart } from 'lucide-react';
import '../../styles/marketplace.css';

const WishlistModal = ({
    isOpen,
    onClose,
    wishlistItems,
    onRemoveFromWishlist,
    onAddToCart,
    selectedCurrency,
    rates
}) => {
    if (!isOpen) return null;

    // Helper to format price
    const formatPrice = (price, baseCurrency) => {
        const displayCurrency = selectedCurrency || baseCurrency;
        const rate = rates && rates[displayCurrency] ? rates[displayCurrency] : 1;
        return `${(price * rate).toFixed(2)} ${displayCurrency}`;
    };

    return createPortal(
        <div className="mp-modal-overlay" style={{ zIndex: 20000 }}>
            <div className="mp-modal-content" style={{ maxWidth: '600px', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
                <div className="mp-modal-header">
                    <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Heart fill="#EF4444" color="#EF4444" size={24} />
                        My Wishlist ({wishlistItems.length})
                    </h2>
                    <button onClick={onClose} className="mp-modal-close"><X size={24} /></button>
                </div>

                <div className="mp-modal-body" style={{ overflowY: 'auto' }}>
                    {wishlistItems.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                            <Heart size={48} style={{ opacity: 0.3, marginBottom: '16px' }} />
                            <p>Your wishlist is empty.</p>
                            <p style={{ fontSize: '14px', marginTop: '8px' }}>Save items you love to find them easily later!</p>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            {wishlistItems.map(item => (
                                <div key={item.id} style={{
                                    display: 'flex',
                                    gap: '16px',
                                    padding: '16px',
                                    border: '1px solid #E5E7EB',
                                    borderRadius: '12px',
                                    alignItems: 'center'
                                }}>
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px', background: '#f4f4f4' }}
                                        onError={(e) => { e.target.style.display = 'none'; }}
                                    />

                                    <div style={{ flex: 1 }}>
                                        <h4 style={{ fontWeight: '600', marginBottom: '4px' }}>{item.title}</h4>
                                        <div style={{ color: '#8548A8', fontWeight: 'bold' }}>
                                            {formatPrice(item.price, item.currency)}
                                        </div>
                                        <div style={{ fontSize: '12px', color: item.inStock ? '#10B981' : '#EF4444', marginTop: '4px' }}>
                                            {item.inStock ? 'In Stock' : 'Out of Stock'}
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        <button
                                            onClick={() => { onAddToCart(item); if (item.inStock) onRemoveFromWishlist(item.id); }}
                                            disabled={!item.inStock}
                                            className="mp-btn-primary"
                                            style={{ padding: '8px 16px', fontSize: '13px' }}
                                        >
                                            <ShoppingCart size={16} style={{ marginRight: '6px' }} />
                                            Add to Cart
                                        </button>
                                        <button
                                            onClick={() => onRemoveFromWishlist(item.id)}
                                            style={{
                                                padding: '8px',
                                                background: 'none',
                                                border: '1px solid #E5E7EB',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#666'
                                            }}
                                        >
                                            <Trash2 size={16} />
                                            <span style={{ marginLeft: '6px' }}>Remove</span>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default WishlistModal;
